<template>
  <div id="doc">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Doc"
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#doc {
  height: 100%;
  width: 100%;
  background: #fff;
}
</style>
